import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { preloadOptions } from '../Options/preloadOptions';

import { getStarredQueryOptions } from './starredQueryHelpers';

export const preloadStarred = ({ isLoggedIn }) => {
	return waitForAllReturnWhenError([
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query(getStarredQueryOptions({})),
		preloadOptions({ isLoggedIn }),
	]);
};
